   function rfc(variant_id){
 document.getElementById('cartrem'+variant_id).style.display='none';
     document.getElementById('spinner'+variant_id).style.display='block';
     var quantity=0;
       jQuery.post('/cart/change.js', {
  
  quantity:quantity,
 id:variant_id,
            
    success:  removesuccess(variant_id)
  
});
   }
   
   function removesuccess(variant_id){ 
      var cust_id= document.getElementById('customer_number').innerHTML;
    var cust_id = cust_id.replace("<a href=\"javascript: void(0)\">", "");
    var cust_id = cust_id.replace("</a>", ""); 
    
    

    
    
     $.post("https://buylocalus.com/apps/blusapp/remove_cart_points.php",{cust_id:cust_id,variant_id:variant_id},function(data){
       
   setInterval(check_cart_remove, 1000,variant_id);                           

  
       
     });
     
   }

function check_cart_remove(variant_id){
                            
jQuery.getJSON('/cart.js', function(cart) {
   var cart_count=cart.items.length;
  
 if (cart_count>0){
     var var_ex=0;
    for (var i = 0, len = cart_count; i < len; i++) {
    
      if (cart.items[i]['variant_id']==variant_id){
        var var_ex=1;
      }
    }

     if (var_ex==0){
       window.location.href = '/cart'; 
     }
   }else{
 window.location.href = '/cart'; 
   
   }
  
  
});
  
}